'use client';

import { createTheme, ThemeOptions } from '@mui/material/styles';
import responsiveBaseTheme from '@/styles/brands/base';
import deepmerge from '@mui/utils/deepmerge';

const mp = createTheme(
	deepmerge(responsiveBaseTheme, {
		palette: {
			primary: {
				main: 'rgba(0, 44, 92, 1)', //#002C5C
			},
			secondary: {
				main: 'rgba(0, 149, 224, 1)', //#0095E0
			},
			accent: {
				main: 'rgba(240, 249, 253)', //#F0F9FD
			},
			lightBackground: {
				main: 'rgba(247, 252, 254, 1)', // #F7FCFE
			},
		},
	} as ThemeOptions),
);

export default mp;
